
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7235648e!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./dropdown.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./dropdown.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7235648e!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dropdown.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tofu-dropdown/src/dropdown.vue
// module id = 584
// module chunks = 0